import {
  Activity,
  Archive,
  Bell,
  Box,
  Cloud,
  Container,
  Cpu,
  Database,
  Folder,
  Globe,
  HardDrive,
  Inbox,
  Key,
  Layers,
  Lock,
  Mail,
  MemoryStick,
  MessageSquare,
  Network,
  Radio,
  RadioTower,
  Server,
  Shield,
  Table,
  Vault,
  Waves,
  Zap,
  type LucideIcon,
} from 'lucide-react';

// Catalog icon names are Lucide names. Only a curated set is bundled (the full set would add
// over a thousand chunks); unknown names fall back to a generic box.
const ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  archive: Archive,
  bell: Bell,
  box: Box,
  cloud: Cloud,
  container: Container,
  cpu: Cpu,
  database: Database,
  folder: Folder,
  globe: Globe,
  'hard-drive': HardDrive,
  inbox: Inbox,
  key: Key,
  layers: Layers,
  lock: Lock,
  mail: Mail,
  'memory-stick': MemoryStick,
  'message-square': MessageSquare,
  network: Network,
  radio: Radio,
  'radio-tower': RadioTower,
  server: Server,
  shield: Shield,
  table: Table,
  vault: Vault,
  waves: Waves,
  zap: Zap,
};

export function ResourceIcon({ name, className }: { name: string | undefined; className?: string }) {
  const Icon = (name && ICONS[name]) || Box;
  return <Icon aria-hidden className={className ?? 'size-4'} />;
}
